class a {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(t) {
    return "9999";
  }
  birthdate() {
    return "39-19-2999";
  }
}
export {
  a as default
};
